import React from 'react';
import {
  Card, Form, Col, Button,
} from 'react-bootstrap';
import { Fab } from 'react-tiny-fab';
import DownloadLink from '../../../../components/common/DownloadLink';
import { mBStyles } from '../../../../helpers';

import 'react-tiny-fab/dist/styles.css';

export default function ButtonsCard({
  can, projId, originId, onEdit, onEditCurrent, onEditMilestones, onSendCommittee, onReturnForRevisionCommittee, onExpertsApprove, onApproveFinal, onDelete,
}) {
  return (
    <Fab event="click" mainButtonStyles={mBStyles}>
      <Card>
        <Card.Body>
          <Form.Group as={Col}>
            { can.Edit && <Button className="me-2" variant="outline-secondary" onClick={() => onEdit()}>Редактировать</Button> }
            { can.EditCurrent && <Button className="me-2" variant="outline-secondary" onClick={onEditCurrent}>Внести изменения в текущую версию</Button> }
            { can.EditCurrentMilestones && <Button className="me-2" variant="outline-secondary" onClick={onEditMilestones}>Добавить вехи в паспорт</Button> }
            { can.SendToCommittee && <Button className="me-2" variant="outline-warning" onClick={onSendCommittee}>Отправить в Проектный офис</Button> }
            { can.ExpertsReturn && <Button className="me-2" variant="outline-danger" onClick={onReturnForRevisionCommittee}>Вернуть на доработку</Button>}
            { can.ApproveFinal && <Button className="me-2" variant="success" onClick={onApproveFinal}>Подписанный скан ЦП</Button> }
            { projId && parseInt(projId) === originId && can.Delete && <Button className="me-2" variant="outline-danger" onClick={onDelete}>Удалить</Button>}
            <DownloadLink variant="outline-secondary" url={`/projs/${projId}/print2`}>Сформировать PDF</DownloadLink>
          </Form.Group>
        </Card.Body>
      </Card>
    </Fab>
  );
}
